import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-details-date-time-availability.reducer';

export const ActivityDetailsDateTimeAvailabilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityDetailsDateTimeAvailabilityEntity = useAppSelector(state => state.activityDetailsDateTimeAvailability.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityDetailsDateTimeAvailabilityDetailsHeading">
          <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.detail.title">
            ActivityDetailsDateTimeAvailability
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.id}</dd>
          <dt>
            <span id="fromDate">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.fromDate">From Date</Translate>
            </span>
          </dt>
          <dd>
            {activityDetailsDateTimeAvailabilityEntity.fromDate ? (
              <TextFormat value={activityDetailsDateTimeAvailabilityEntity.fromDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="toDate">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.toDate">To Date</Translate>
            </span>
          </dt>
          <dd>
            {activityDetailsDateTimeAvailabilityEntity.toDate ? (
              <TextFormat value={activityDetailsDateTimeAvailabilityEntity.toDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="hour">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.hour">Hour</Translate>
            </span>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.hour}</dd>
          <dt>
            <span id="minute">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.minute">Minute</Translate>
            </span>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.minute}</dd>
          <dt>
            <span id="ampm">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.ampm">Ampm</Translate>
            </span>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.ampm}</dd>
          <dt>
            <span id="adultCount">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.adultCount">Adult Count</Translate>
            </span>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.adultCount}</dd>
          <dt>
            <span id="userName">
              <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.userName">User Name</Translate>
            </span>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.userName}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityDetailsDateTimeAvailability.activity">Activity</Translate>
          </dt>
          <dd>{activityDetailsDateTimeAvailabilityEntity.activity ? activityDetailsDateTimeAvailabilityEntity.activity.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-details-date-time-availability" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/activity-details-date-time-availability/${activityDetailsDateTimeAvailabilityEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityDetailsDateTimeAvailabilityDetail;
